import React from 'react'

import { EmptyDate, formatDateTime } from '@cbgms/base/utils/datetime'

export interface IDateCell {
  content: string
}

export const DateCell: React.FC<IDateCell> = props => {
  return props.content === EmptyDate ? null : <>{formatDateTime(props.content)}</>
}

export default React.memo(DateCell)
